import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    minHeight: "143px",
    padding: "16px",
    gap: "10px",
    borderRadius: "4px",
    opacity: 1,
    backgroundColor: theme.palette.common.white,
    boxSizing: "border-box",
  },
  summaryTitle: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "140%",
    letterSpacing: 0,
    leadingTrim: "cap-height",
    color: theme.palette.secondary.main,
    textAlign: "right",
    width: "100%",
    margin: 0,
  },
  fieldsRow: {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    flex: 1,
    overflowX: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  imageCell: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  vehicleImage: {
    width: "63px",
    height: "63px",
    borderRadius: "4px",
    objectFit: "cover",
    flexShrink: 0,
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: "1 1 0",
    minWidth: 0,
  },
  dropdownField: {
    alignItems: "flex-end",
  },
  label: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "140%",
    color: theme.palette.text.primary,
    textAlign: "right",
    whiteSpace: "nowrap",
  },
  valueRow: {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    gap: "4px",
  },
  value: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "140%",
    color: theme.palette.secondary.main,
    textAlign: "right",
    whiteSpace: "nowrap",
  },
}));
